var _style, _g, _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTricolor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1001.1 251.1",
    style: {
      enableBackground: "new 0 0 1001.1 251.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E31231;}\n\t.st1{fill:#00519E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "250.1,150.1 150.1,150.1 250.1,250.1 350.1,250.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "100.1,0.1 0.1,0.1 100.1,100.1 50.1,150.1 150.1,150.1 200.1,100.1  "
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "324.3,38.8 324.3,60.1 298.4,60.1 298.4,128.8 276,128.8 276,60.1 250.1,60.1 250.1,38.8 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "456.7,95.2 490.5,38.8 513.7,38.8 513.7,128.8 492.1,128.8 492.1,72.2 458.3,128.8 435.1,128.8   435.1,38.8 456.7,38.8 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "559.6,70.5 562.2,70.5 588.3,38.8 617.1,38.8 580.8,80.6 620.1,128.8 590.5,128.8 561.8,91 559.6,91   559.6,128.8 537.2,128.8 537.2,38.8 559.6,38.8 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M665.4,38.8c-27,0-44.7,18.4-44.7,45s18.1,45,44.7,45s44.4-18.6,44.4-45.2S692.4,38.8,665.4,38.8z M665.4,107.8  c-14.5,0-22.6-10-22.6-24s8.3-24,22.6-24s22.3,9.9,22.3,23.8S679.9,107.7,665.4,107.8L665.4,107.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.4,38.8h-38.3v90h22.4v-24.3h15.6c19.7,0,35-12.3,35-32.7C417.1,51.6,402,38.8,382.4,38.8z M382.9,83.1  h-16.4V60.1h16c7.7,0,12.2,3.7,12.2,11.6C394.8,79.3,390.4,83.1,382.9,83.1L382.9,83.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M965.4,38.8h-38.3v90h22.4v-24.3h15.6c19.7,0,35-12.3,35-32.7C1000.1,51.6,985,38.8,965.4,38.8z M965.9,83.1  h-16.4V60.1h16c7.7,0,12.2,3.7,12.2,11.6C977.7,79.3,973.3,83.1,965.9,83.1L965.9,83.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M865.5,38.8c-27,0-44.7,18.4-44.7,45s18.1,45,44.7,45s44.4-18.6,44.4-45.2S892.5,38.8,865.5,38.8z M865.5,107.8  c-14.5,0-22.6-10-22.6-24s8.3-24,22.6-24s22.3,9.9,22.3,23.8S880.1,107.7,865.5,107.8L865.5,107.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M758.8,60.1c-0.5,6.2-1,12.5-1.7,18.7c-0.7,6.6-1.6,13-2.8,19.3c-3.5,18.1-13.1,29.7-31.1,30.6  c-1.8,0.1-3.6,0.1-5.5,0v-21.6c10,0.3,12.8-3.5,14.7-12.9c1.2-6.1,2.3-14.3,3.1-22.8c1.1-10.9,2-21.8,2.6-32.7h67v89.8h-22.4V60.1  H758.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTricolor);
export default __webpack_public_path__ + "static/media/tricolor.5e77b5eb1e19b8932a8cca165850c864.svg";
export { ForwardRef as ReactComponent };